export default "__VITE_ASSET__Qoq2Yp6k__"